'use strict';

var _classCallCheck = require("/app/node_modules/@babel/runtime/helpers/classCallCheck");

var _createClass = require("/app/node_modules/@babel/runtime/helpers/createClass");

var shimmer = require('shimmer');

var log = require('./log');

var platform = require('./platform');

var _require = require('./util'),
    isTrue = _require.isTrue,
    isFalse = _require.isFalse;

shimmer({
  logger: function logger() {}
});
var plugins = platform.plugins;
var disabldPlugins = platform.env('DD_TRACE_DISABLED_PLUGINS');

var collectDisabledPlugins = function collectDisabledPlugins() {
  return new Set(disabldPlugins && disabldPlugins.split(',').map(function (plugin) {
    return plugin.trim();
  }));
};

function cleanEnv(name) {
  return platform.env("DD_TRACE_".concat(name.toUpperCase()).replace(/[^a-z0-9_]/ig, '_'));
}

function getConfig(name) {
  var config = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};

  if (!name) {
    return config;
  }

  var enabled = cleanEnv("".concat(name, "_ENABLED"));

  if (enabled !== undefined) {
    config.enabled = isTrue(enabled);
  }

  var analyticsEnabled = cleanEnv("".concat(name, "_ANALYTICS_ENABLED"));
  var analyticsSampleRate = Math.min(Math.max(cleanEnv("".concat(name, "_ANALYTICS_SAMPLE_RATE")), 0), 1);

  if (isFalse(analyticsEnabled)) {
    config.analytics = false;
  } else if (!Number.isNaN(analyticsSampleRate)) {
    config.analytics = analyticsSampleRate;
  } else if (isTrue(analyticsEnabled)) {
    config.analytics = true;
  }

  return config;
}

var Instrumenter =
/*#__PURE__*/
function () {
  function Instrumenter(tracer) {
    _classCallCheck(this, Instrumenter);

    this._tracer = tracer;
    this._loader = new platform.Loader(this);
    this._enabled = false;
    this._names = new Set();
    this._plugins = new Map();
    this._instrumented = new Map();
    this._disabledPlugins = collectDisabledPlugins();
  }

  _createClass(Instrumenter, [{
    key: "use",
    value: function use(name, config) {
      if (typeof config === 'boolean') {
        config = {
          enabled: config
        };
      }

      config = getConfig(name, config);

      try {
        this._set(plugins[name.toLowerCase()], {
          name: name,
          config: config
        });
      } catch (e) {
        log.debug("Could not find a plugin named \"".concat(name, "\"."));
      }

      if (this._enabled) {
        this._loader.reload(this._plugins);
      }
    }
  }, {
    key: "enable",
    value: function enable(config) {
      var _this = this;

      config = config || {};
      this._enabled = true;

      if (config.plugins !== false) {
        Object.keys(plugins).filter(function (name) {
          return !_this._plugins.has(plugins[name]);
        }).forEach(function (name) {
          _this._set(plugins[name], {
            name: name,
            config: getConfig(name)
          });
        });
      }

      this._loader.reload(this._plugins);
    }
  }, {
    key: "disable",
    value: function disable() {
      var _iteratorNormalCompletion = true;
      var _didIteratorError = false;
      var _iteratorError = undefined;

      try {
        for (var _iterator = this._instrumented.keys()[Symbol.iterator](), _step; !(_iteratorNormalCompletion = (_step = _iterator.next()).done); _iteratorNormalCompletion = true) {
          var instrumentation = _step.value;
          this.unpatch(instrumentation);
        }
      } catch (err) {
        _didIteratorError = true;
        _iteratorError = err;
      } finally {
        try {
          if (!_iteratorNormalCompletion && _iterator.return != null) {
            _iterator.return();
          }
        } finally {
          if (_didIteratorError) {
            throw _iteratorError;
          }
        }
      }

      this._plugins.clear();

      this._enabled = false;

      this._loader.reload(this._plugins);
    }
  }, {
    key: "wrap",
    value: function wrap(nodules, names, wrapper) {
      nodules = [].concat(nodules);
      names = [].concat(names);
      nodules.forEach(function (nodule) {
        names.forEach(function (name) {
          if (typeof nodule[name] !== 'function') {
            throw new Error("Expected object ".concat(nodule, " to contain method ").concat(name, "."));
          }

          Object.defineProperty(nodule[name], '_datadog_patched', {
            value: true,
            configurable: true
          });
        });
      });
      shimmer.massWrap.call(this, nodules, names, wrapper);
    }
  }, {
    key: "unwrap",
    value: function unwrap(nodules, names, wrapper) {
      nodules = [].concat(nodules);
      names = [].concat(names);
      shimmer.massUnwrap.call(this, nodules, names, wrapper);
      nodules.forEach(function (nodule) {
        names.forEach(function (name) {
          nodule[name] && delete nodule[name]._datadog_patched;
        });
      });
    }
  }, {
    key: "wrapExport",
    value: function wrapExport(moduleExports, wrapper) {
      if (typeof moduleExports !== 'function') return moduleExports;
      var props = Object.keys(moduleExports);

      var shim = function shim() {
        return moduleExports._datadog_wrapper.apply(this, arguments);
      };

      for (var _i = 0, _props = props; _i < _props.length; _i++) {
        var prop = _props[_i];
        shim[prop] = moduleExports[prop];
      }

      moduleExports._datadog_wrapper = wrapper;
      return shim;
    }
  }, {
    key: "unwrapExport",
    value: function unwrapExport(moduleExports) {
      if (moduleExports && moduleExports._datadog_wrapper) {
        moduleExports._datadog_wrapper = moduleExports;
      }

      return moduleExports;
    }
  }, {
    key: "load",
    value: function load(plugin, meta) {
      var _this2 = this;

      if (!this._enabled) return;
      var instrumentations = [].concat(plugin);
      var enabled = meta.config.enabled !== false;
      platform.metrics().boolean("datadog.tracer.node.plugin.enabled.by.name", enabled, "name:".concat(meta.name));

      try {
        instrumentations.forEach(function (instrumentation) {
          _this2._loader.load(instrumentation, meta.config);
        });
      } catch (e) {
        log.error(e);
        this.unload(plugin);
        log.debug("Error while trying to patch ".concat(meta.name, ". The plugin has been disabled."));
        platform.metrics().increment("datadog.tracer.node.plugin.errors", true);
      }
    }
  }, {
    key: "unload",
    value: function unload(plugin) {
      var _this3 = this;

      [].concat(plugin).forEach(function (instrumentation) {
        _this3.unpatch(instrumentation);

        _this3._instrumented.delete(instrumentation);
      });

      var meta = this._plugins.get(plugin);

      if (meta) {
        this._plugins.delete(plugin);

        platform.metrics().boolean("datadog.tracer.node.plugin.enabled.by.name", false, "name:".concat(meta.name));
      }
    }
  }, {
    key: "patch",
    value: function patch(instrumentation, moduleExports, config) {
      var instrumented = this._instrumented.get(instrumentation);

      if (!instrumented) {
        this._instrumented.set(instrumentation, instrumented = new Set());
      }

      if (!instrumented.has(moduleExports)) {
        instrumented.add(moduleExports);
        return instrumentation.patch.call(this, moduleExports, this._tracer._tracer, config);
      }
    }
  }, {
    key: "unpatch",
    value: function unpatch(instrumentation) {
      var _this4 = this;

      var instrumented = this._instrumented.get(instrumentation);

      if (instrumented) {
        instrumented.forEach(function (moduleExports) {
          try {
            instrumentation.unpatch.call(_this4, moduleExports, _this4._tracer);
          } catch (e) {
            log.error(e);
          }
        });
      }
    }
  }, {
    key: "_set",
    value: function _set(plugin, meta) {
      if (this._disabledPlugins.has(meta.name)) {
        log.debug("Plugin \"".concat(meta.name, "\" was disabled via configuration option."));
      } else {
        this._plugins.set(plugin, meta);

        this.load(plugin, meta);
      }
    }
  }]);

  return Instrumenter;
}();

module.exports = Instrumenter;